import { colors } from '../../colors';
var address = {
  addressColor: colors.onyx
};
export default address;